import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefund.Save.IRequest;
type Response = Api.Sales.ContractRefund.Save.IResponse;
type Headers = Api.Sales.ContractRefund.Save.IHeaders;
const url = '/api/Sales/ContractRefund';
export default async function contractRefundSaveApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
